import { render, staticRenderFns } from "./WorkoutFilter.vue?vue&type=template&id=bb837a0c&scoped=true"
import script from "./WorkoutFilter.vue?vue&type=script&lang=js"
export * from "./WorkoutFilter.vue?vue&type=script&lang=js"
import style1 from "./WorkoutFilter.vue?vue&type=style&index=1&id=bb837a0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb837a0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
